import { FilterFieldDropdown } from '../models/filter-field-dropdown.model';
import { FilterField } from '../models/filter-field.model';

export const isFilterFieldDropdown = (
  filterField: FilterField,
): filterField is FilterFieldDropdown =>
  !!(filterField as FilterFieldDropdown).entries$;
